module.exports = __webpack_public_path__ + "img/arrow-left.885a3d19.svg";